import React from 'react'
import cs from 'classnames'

type RadioListProps = {
  name: string
  options: Array<{ label: string; value: string }>
  value: string
  onChange: (props: { name: string; value: string }) => void
  className?: string
  radioClassName?: string
}

export const RadioList = ({
  name,
  options,
  value,
  onChange,
  className,
  radioClassName,
}: RadioListProps) => (
  <ul className={cs('list-bare form-radio-list', className)}>
    {options.map(({ label, value }) => (
      <li key={value} className="form-radio">
        <input
          type="radio"
          name={name}
          id={`${name}-${value}`}
          className={cs(radioClassName)}
          value={value}
          onChange={() => onChange({ name, value })}
        />
        <label htmlFor={`${name}-${value}`} className={cs(radioClassName)}>
          <span>{label}</span>
        </label>
      </li>
    ))}
  </ul>
)
